import { motion } from "framer-motion";
import { PhoneCall, Check } from "lucide-react";
import a7 from "../Assets/a7.png";

const PromoPoster = () => {
  return (
    <div className="w-full bg-[#0b122a] py-16 px-6">
      {/* Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7 }}
        className="max-w-6xl mx-auto rounded-3xl shadow-[0_0_60px_rgba(0,0,0,0.6)] bg-gradient-to-br from-[#0e1a3d] to-[#0b1233] border border-white/10 p-6 md:p-10"
      >
        {/* TOP SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
          {/* Academy Logo / Image in Circle */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex justify-center"
          >
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-yellow-400 shadow-2xl">
              <img
                src={a7}
                className="w-full h-full object-cover"
                alt="Academy"
              />
            </div>
          </motion.div>

          {/* TITLE */}
          <div className="col-span-2 text-center md:text-left text-white">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide text-yellow-400 drop-shadow-lg">
              HAIFA DEFENCE ACADEMY
            </h1>

            <p className="text-gray-300 text-base md:text-lg mt-4">
              Premier Coaching for India’s Top Defence Schools
            </p>

            {/* Highlight Bar */}
            <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-3">
              {["SAINIK SCHOOL", "RMS", "RIMC", "NAVODAYA"].map((item, i) => (
                <span
                  key={i}
                  className="px-4 py-1 bg-white/10 text-white rounded-full border border-white/20 text-sm backdrop-blur-md"
                >
                  {item}
                </span>
              ))}
            </div>

            {/* Blinking Red Admission Open Badge */}
            <motion.div
              animate={{ opacity: [1, 0.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop",
              }}
              className="inline-block mt-6 px-6 py-2 bg-red-600 text-white font-bold rounded-full text-lg shadow-lg tracking-wide select-none"
            >
              Admission Open for Coaching
            </motion.div>
          </div>
        </div>

        {/* Middle Divider Line */}
        <div className="w-full h-px bg-white/20 my-10"></div>

        {/* COURSE SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-2 text-white">
          {/* LEFT SIDE TEXT */}
          <div>
            <h2 className="text-3xl font-bold text-yellow-300 mb-6">
              What We Offer
            </h2>

            <div className="space-y-4 text-lg">
              {[
                "Complete Sainik School Entrance Coaching",
                "RMS – Rashtriya Military School Training",
                "RIMC Full Preparation Program",
                "Navodaya Vidyalaya (JNV) Coaching",
                "Schooling + Academic + Physical + Interview Guidance",
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <Check className="text-green-400 mt-1" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE CTA BOX */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white/10 border border-white/20 rounded-2xl p-6 md:p-8 backdrop-blur-xl shadow-xl"
          >
            <h3 className="text-yellow-300 text-2xl font-bold mb-4">
              Admission Open 2025–26
            </h3>

            <p className="text-gray-200 mb-6">
              Limited Seats • High Success Rate • Expert Faculty
            </p>

            {/* CONTACT BUTTON */}
            <a
              href="tel:9997450792"
              className="block text-center px-8 py-4 bg-yellow-400 text-black font-bold rounded-xl text-lg shadow-[0_5px_20px_rgba(255,223,0,0.5)] hover:bg-yellow-300"
            >
              <PhoneCall className="inline-block mr-2" />
              Call Now: 9997450792
            </a>
          </motion.div>
        </div>

        {/* FOOTER */}
        <div className="mt-10 text-center text-gray-300">
          📍 Agra • 🌐 www.haifadefenceacademy.com
          <br />
          ☎️ 9997450792, 9997450793
        </div>
      </motion.div>
    </div>
  );
};

export default PromoPoster;
